module.exports = __webpack_public_path__ + "static/img/AMT.d538430.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/AMT.png
// module id = LJ+U
// module chunks = 34